import type {Module} from 'vuex'
import {BundleConfig} from "@/types/client";

const LOCAL_STORAGE_KEY = 'voxbet_bundle_template_history'

function getInitialHistory() {
	try {
		const str = localStorage.getItem(LOCAL_STORAGE_KEY)
		return str ? JSON.parse(str) : {}
	} catch (e) {
		return {}
	}
}

function initialState() {
	return {
		history: getInitialHistory()
	}
}

export interface BundleTemplateHistoryState {
	history: Record<string, BundleConfig[]>
}

const MAX_HISTORY = 10

export function isSameConfig(a: BundleConfig, b: BundleConfig): boolean {
	return a.bundleId === b.bundleId && a.variantId === b.variantId
}

export const bundleTemplateHistoryModule: Module<BundleTemplateHistoryState, unknown> = {
	namespaced: true,

	state: initialState,

	getters: {
		historyFor: (state) => (contextId: string): BundleConfig[] => {
			return (state.history[contextId] ?? []).filter((item): item is BundleConfig => item != null)
		},

		latestFor: (state) => (contextId: string): BundleConfig | null => {
			return state.history[contextId]?.[0] ?? null
		},
	},

	mutations: {
		SELECT(
				state,
				payload: { contextId: string; bundleConfig: BundleConfig }
		): void {
			const { contextId, bundleConfig } = payload
			const existing = state.history[contextId] ?? []

			const filtered = existing.filter((c) => !isSameConfig(c, bundleConfig))
			const updated = [bundleConfig, ...filtered].slice(0, MAX_HISTORY)
			state.history = { ...state.history, [contextId]: updated }
			localStorage.setItem(LOCAL_STORAGE_KEY, JSON.stringify(state.history))
		},

		CLEAR_CONTEXT(state, contextId: string): void {
			const { [contextId]: _, ...rest } = state.history
			state.history = rest
			localStorage.setItem(LOCAL_STORAGE_KEY, JSON.stringify(state.history))
		},

		CLEAR_ALL(state): void {
			state.history = {}
			localStorage.removeItem(LOCAL_STORAGE_KEY)
		},
	},

	actions: {
		select(
				{ commit },
				payload: { contextId: string; bundleConfig: BundleConfig }
		): void {
			commit('SELECT', payload)
		},

		clearContext({ commit }, contextId: string): void {
			commit('CLEAR_CONTEXT', contextId)
		},

		clearAll({ commit }): void {
			commit('CLEAR_ALL')
		},
	},
}
